import subscriptionStrings from "rivals/shared/strings/subscription";

export default {
  ...subscriptionStrings,
  title: "CONFIRM SUBSCRIPTION"
};
